/* eslint-disable camelcase */
import React from 'react';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { Dialog } from 'primereact/dialog';
import './deleteDraftCAP.scss';
import warningImage from '../../../assets/warningImage.png';
import { useDeleteActionPlanMutation } from '../activeActionPlans/activeActionPlansSlice';

interface DeleteDraftCAPProps {
    coachingActionPlanId: number;
    showDialog: boolean;
    setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteDraftCAP: React.FC<DeleteDraftCAPProps> = ({ coachingActionPlanId, showDialog, setShowDialog }) => {
    const [deleteActionPlan, { isLoading: isClosing }] = useDeleteActionPlanMutation();

    
    const handleDeleteActionPlan = () => {
        deleteActionPlan(
            coachingActionPlanId
        )
            .unwrap()
            .then(() => {
                setShowDialog(false);
                toast.success('Action Plan deleted successfully');
            })
            .catch(() => {
                toast.error('Failed to delete Action Plan');
            });
    };
    // ── Main table view ────────────────────────────────────────────────
    return (
        <div>            
            <Dialog
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                style={{ borderRadius: '24px', overflow: 'hidden', width: '550px' }}
                modal draggable={false} resizable={false} closable={false} showHeader={false}
            >
                <div className="delete_dialog__icon"><img src={warningImage} alt="warning" /></div>
                <div className="delete_dialog_title"><h2>Delete Draft</h2></div>
                <p className="delete_dialog__message">
                    Are you sure you want to delete this draft? <br />
                    (This action can&apos;t be undone)
                </p>
                <div className="ra-dialog__actions">
                    <Button
                        label="Cancel"
                        className="ra-dialog__btn-secondary"
                        onClick={() => setShowDialog(false)}
                        disabled={isClosing}
                    />
                    <Button
                        label="Delete"
                        className="ra-dialog__btn-primary"
                        onClick={handleDeleteActionPlan}
                        loading={isClosing}
                    />
                </div>
            </Dialog>
        </div>
    );
};

export default DeleteDraftCAP;